import * as React from 'react';
import StarItem from 'PyzShopUi/scripts/product-review/components/total-review-rating/StarItem';
import Button from 'PyzShopUi/scripts/react/common/components/form/Button';
import {IStarItem, IStarItemRatingSum} from 'PyzShopUi/scripts/product-review/interfaces';
import { MAX_STAR_TITLE } from 'PyzShopUi/scripts/product-review/constants';
import MiddlewareEventBus from 'PyzShopUi/scripts/react/common/lib/MiddlewareEventBus';
import { DialogEvent } from 'PyzShopUi/scripts/react/common/events/dialogEvent';
import { NAME_WRITING_PRODUCT_REVIEW_DIALOG } from 'PyzShopUi/scripts/product-review/constants/forms';
import EventBus from 'PyzShopUi/scripts/utils/eventBus';
import {EDialogEvents} from 'PyzShopUi/scripts/modules/events/dialogEvent';
import { useTranslationHook } from 'PyzShopUi/scripts/utils/translationHook';

interface ITotalReviewRatingProps {
    averageRating: number;
    reviewCount: number;
    ratingStars: IStarItem[];
    dispatch: React.Dispatch<any>;
}

const TotalReviewRating: React.FunctionComponent<ITotalReviewRatingProps> = props => {
    const { averageRating, reviewCount, ratingStars, dispatch } = props;
    const onClickAverageRating = () => {};
    const sortedStars = ratingStars.sort((a, b) => b.averageRating - a.averageRating);
    const { translate } = useTranslationHook();

    const openDialog = event => {
        event.preventDefault();
        EventBus.getInstance().publish(EDialogEvents.OPEN_DIALOG, {id: NAME_WRITING_PRODUCT_REVIEW_DIALOG});
    };

    const displayRatingStars = () => sortedStars.map((starItem: IStarItem) => {
        const onClickRating = () => {
        };

        return (
            <StarItem
                key={starItem.averageRating}
                averageRating={starItem.averageRating}
                reviewCount={starItem.reviewCount.count}
                isActive={starItem.reviewCount.isActive}
                isLinkShownFull={false}
                onClick={onClickRating}
                dispatch={dispatch}
            />
        );
    });

    return (
        <div className="total-review-rating">
            <div className="title">
                <div className="title__rating heading3">{averageRating}</div>
                <div className="heading3">{translate('of {{maxStars}} stars', { replace: { maxStars: MAX_STAR_TITLE }, ns: 'article-detail' })}</div>
            </div>
            <StarItem
                averageRating={averageRating}
                reviewCount={reviewCount}
                onClick={onClickAverageRating}
                dispatch={dispatch}
            />
            <Button
                label={translate('Writing a review', { ns: 'article-detail' })}
                color={'red'}
                icon={'arrow'}
                iconPosition={'right'}
                onClick={openDialog}
            />
            <div className="total-review-rating__star-detail hide-for-small-only">
                <h2 className="heading3">{translate('review', { count: ratingStars.length, ns: 'article-detail' })}</h2>
                {displayRatingStars()}
            </div>
        </div>
    );
};

export default TotalReviewRating;
